import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'mz-intl'
import { getActiveLanguage } from 'app/sagas/selectors'
import messages from '../../../messages.intl'
import style from './style.css'

const CANCELLATION_TERMS_LOCALE_MAP = {
  it_IT: 'it-it',
  de_DE: 'de-de',
  es: 'es',
  fr: 'fr',
  zh_CN: 'zh-cn',
}
const BASE_URL = 'https://www.mozio.com/extended-cancellation-terms-and-conditions'

export default function ExtendedCancellationDescription() {
  const locale = useSelector(getActiveLanguage)
  const urlSegment = CANCELLATION_TERMS_LOCALE_MAP[locale]
  const url = urlSegment
    ? `https://www.mozio.com/${urlSegment}/extended-cancellation-terms-and-conditions`
    : BASE_URL

  return (
    <span className={style.container}>
      <a
        className={style.link}
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        <FormattedMessage message={messages.EXTENDED_CANCELLATION_POLICY_LINK} />
      </a>
    </span>
  )
}
